<!-- eslint-disable -->
<template lang="pug">
    table.classifications-table
        tr.classifications-table__row(v-for='(row, rowIndex) in classificationsTable')
            td.classifications-table__cell(v-for='(item, itemIndex) in row', :class="{'classifications-table__cell--small': maxTableSize > 5}")
                .classifications-table__item(
                    :class="{\
                        'classifications-table__item--correct': item.type === 'correct-link',\
                        'classifications-table__item--tipped': item.helpMarker,\
                    }"
                )
                    drag.classifications-container__drag(
                        v-if="linksType === 'image' && (item.type !== 'dropZone' || item.type === 'correct-link')",
                        :draggable="gameStarted && item.type !== 'correct-link'",
                        :transfer-data="{ item: item, index: itemIndex, rowIndex: rowIndex, from: 'classifications' }"
                        @dragstart="$emit('dragStarted')"
                        @dragend="$emit('dragEnded')"
                    )
                        img.classifications-link(
                            :src='item.value | apiFile',
                            :data-index='itemIndex',
                            :draggable="gameStarted && item.type !== 'correct-link'"
                        )
                    drop.drop-zone(
                        v-if="item.type === 'dropZone'",
                        @drop='dropItemInMatrix(item, rowIndex, $event)'
                    )
                        .drop-zone__shake-zone
</template>

<script>
    /*eslint-disable*/
    import { Drag, Drop } from 'vue-drag-drop';
    const DEFAULT_VOLUME = 0.6;

    export default {
        props: {
            classificationsTable: {
                type: Array,
                default: () => {
                  return [];
                }
            },
            gameStarted: Boolean,
            linkDropped: Boolean,
            linksType: String,
            tableSize: Object
        },
        data () {
            return {
                soundInstance: null,
                isInputFocused: false,
            }
        },
        mounted () {
            window.addEventListener('resize', this.calculateSizeForMatrixTable);
            this.calculateSizeForMatrixTable();
        },
        watch: {
            gameStarted(value) {
                value && this.$nextTick(this.calculateSizeForMatrixTable);
            },
            linkDropped(value) {
                if (value) {
                    this.$nextTick(() => {
                        this.calculateSizeForMatrixTable();
                        this.$emit('linkResized')
                    });
                }
            },
            '$root.sidebar' (val) {
                setTimeout(() => this.calculateSizeForMatrixTable(), 200);
            }
        },
        updated () {
            this.isInputFocused = this.helperModeOn === true ? false : this.isInputFocused;
            if (!this.isInputFocused && this.$refs.input && this.$refs.input[0]) {
                this.$refs.input[0].blur();
                this.focusNextElement();
            }
            (this.tableSize.amountOfRows === 10 || this.tableSize.amountOfRows === 6) && this.calculateSizeForMatrixTable();
        },
        computed: {
            maxTableSize () {
                return Math.max(this.tableSize.amountOfColumns, this.tableSize.amountOfRows);
            }
        },
        methods: {
            calculateSizeForMatrixTable () {
                const windowWidth = window.innerWidth;
                const windowHeight = window.innerHeight;
                let classificationsTable = document.querySelector('.classifications-table');
                const containerWidth = windowWidth < 1200
                        ? classificationsTable.parentElement.clientWidth - 30
                        : classificationsTable.parentElement.clientWidth - 150;
                const maxTableWidth = Math.min(classificationsTable.clientWidth, containerWidth);
                const maxTableHeight = this.tableSize.amountOfRows > 6
                        ? classificationsTable.clientHeight
                        : Math.min(windowHeight - 450, classificationsTable.clientHeight)
                let items = Array.from(document.querySelectorAll('.classifications-table__cell'));
                let links = Array.from(document.querySelectorAll('.link'));
                let dropBox = document.querySelector('.drop-box');
                let playBoxDrop = document.querySelector('.play-box__drop');
                let answersContainer = document.querySelector('.answers-container')
                let itemSize = Math.max(maxTableWidth / this.tableSize.amountOfColumns, maxTableHeight / this.tableSize.amountOfRows);
                if (itemSize > 145) {
                    itemSize = 145;
                }
                if (itemSize < 70) {
                  itemSize = 70;
                }
                classificationsTable.style['width'] = itemSize * this.tableSize.amountOfColumns + 'px';
                classificationsTable.style['height'] = itemSize * this.tableSize.amountOfRows + 'px';
                items.forEach(item => {
                    item.style['height'] = 100 / this.tableSize.amountOfRows + '%';
                    item.style['width'] = 100 / this.tableSize.amountOfColumns + '%';
                });
                itemSize = Math.max(items[0].clientWidth, 120);
                const paddingOfLinks = 40;
                if (dropBox && playBoxDrop && answersContainer) {
                    dropBox.style['height'] = (0.75 * itemSize + paddingOfLinks) + 'px';
                    playBoxDrop.style['height'] = (0.9 * itemSize + paddingOfLinks) + 'px';
                    answersContainer.style['min-width'] = 1.5 * itemSize + 'px';
                }
                links.forEach(item => {
                    item.style['height'] = 0.75 * itemSize + 'px'
                    item.style['width'] = 0.75 * itemSize + 'px'
                });
            },
            dropItemInMatrix (link, rowIndex, data) {
                if (data && (data.from === 'answers-box' || data.from === 'classifications')) {
                    this.soundInstance = this.$createjs.Sound.play("classificationsDrop");
                    this.soundInstance.volume = DEFAULT_VOLUME;
                    if (data.from === 'answers-box') {
                        this.$set(this.classificationsTable[rowIndex], this.classificationsTable[rowIndex].indexOf(link), _.cloneDeep(data.item));
                        this.$emit('dropItemInMatrix', data.index);
                    } else {
                        this.$set(this.classificationsTable[rowIndex], this.classificationsTable[rowIndex].indexOf(link), _.cloneDeep(data.item));
                        this.$set(this.classificationsTable[data.rowIndex], this.classificationsTable[data.rowIndex].indexOf(data.item), {type: 'dropZone'});
                    }
                }
            },
            focusInput (event) {
                this.isInputFocused = this.$refs.input.some(element => _.isEqual(element, event.target));
            },
            focusNextElement(index = 0) {
                let uncompletedItems = _.flatten(this.classificationsTable).filter(item => item.type === "textInput");
                let completedItems = _.flatten(this.classificationsTable).filter((item, itemIndex) => item.type !== "textInput" && itemIndex < index);
                index = index - completedItems.length;
                index = index >= uncompletedItems.length ? index % uncompletedItems.length : index;
                let isMatrixCompleted = !_.flatten(this.classificationsTable).some(item => item.value === '');
                if (isMatrixCompleted) {
                    this.isInputFocused = false;
                    this.$emit('processReply');
                } else if (this.$refs.input[index]) {
                    this.$refs.input[index].focus();
                }
            },
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.calculateSizeForMatrixTable);
        },
        components: {
            Drop,
            Drag
        }
    }
</script>

<style scoped lang="scss">
    .link {
        display: inline-flex;
    }

    .link-icon {
        width: 50px;
    }

    .link-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .drop-zone {
        display: inline-flex;
        width: 100%;
        height: 100%;
    }

    .drop-zone__shake-zone {
        width: 100%;
        height: 100%;
        margin: auto;
        background: white;
        border-radius: 12px;
    }

    .classifications-container__drag {
        display: inline-flex;
        justify-content: center;
        align-items: center;
    }

    .classifications-link {
        display: inline-block;
        vertical-align: middle;
        box-sizing: border-box;
        border-radius: 12px;
        margin-left: 20px;
        cursor: grab;
        max-height: 200px;
        max-width: 250px;
    }

    .classifications-link {
        margin-left: 0;
    }

    .classifications-table {
        border: none;
        border-spacing: 0;
        border-collapse: collapse;
        width: 100%;
        height: 100%;
        margin: 0;
        table-layout: fixed;
        box-sizing: border-box;
    }

    .classifications-table tr:first-child td{
        border-top: none;
    }

    .classifications-table tr:last-child td{
        border-bottom: none;
    }

    .classifications-table tr td:first-child{
        border-left: none;
    }

    .classifications-table tr td:last-child{
        border-right: none;
    }

    .classifications-table__cell {
        border: 12px solid transparent;
        height: 200px;
        width: 200px;
        border-top: 0;
        border-left: 0;
        text-align: center;
        vertical-align: middle;
        background: inherit;
        box-sizing: border-box;
    }

    .classifications-table__cell--small {
        border: 5px solid transparent;
    }

    .classifications-table__item {
        width: 100%;
        height: 100%;
        margin: auto;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 38px;
        user-select: none;
        border-radius: 12px;
        background-color: white;
        transition: background-color 0.1s;
        border: 3px solid $hsl-color-gray-92;
        box-sizing: border-box;
        img {
            max-height: 100%;
            max-width: 100%;
        }
    }

    .classifications-table__item--correct {
        border: 3px solid $hsl-color-green-58;
    }

    .classifications-table__item--tipped {
        border: 3px solid $hsl-color-yellow-66;
    }

    @import '@/assets/sass/animations/shake.scss';
</style>
